export const service_controllers_methods = {
  offline: {
    controller: "printer/",
    methods: {
      getPrinters: "get-printers",
      testPrint: "test-print/:printerName",
      setPrint: "set-print",
      getTemporaryFolder: "get-temporary-folder"
    }
  },
  billing: {
    controller: "rw57jQqEDqsGN1w/",
    methods: {
      AddBillingDetail: "bJokQ4gc5T",
      GetBilledProducts: "MJTPwb8QH5",
      GetInitialization: "lk4HwKSkaj",
      GetBills: "Lp7O4jUQxc",
      RemoveBillingDetail: "n0Il2Gp0xi",
      UpdateBillingStatus: "VPU1iAs317",
      SaveReceiptTemplate: "KsIoCcL2i0",
      GetReceiptTemplate: "MVsKM2G8Tc",
      UpdateBusinessType: "lHqWlUvnTj",
      GetDeletedItems: "ob9xkOFkOn",
      UpdateBusinessBRN: "ppaOsA2rM7",
      UpdateQty: "HhJlovMUGr",
      OnAction: "QiGjIc1CzH",
      SaveAppointment: "tNryhpYpXr",
      GetAppointment: "Xc5Swaquya",
      ReturnProducts: "aYzVrN8tAr",
      GetReturnInitialization: "elFSISSFH0",
      SaveSerialNumbers: "uSt2nartot",
      GetSerialNumberMapInitialization: "QO7MaVRR8P",
      CopyBill: "lIaQdzzELk",
      GetBillingIdByToken: "xzkLgFs5hi",
      GetBusinessIdByBillingId: "QToECG0Eal",
      GetSalesReport: "LLyEi7WsYw",
      GetSalesReportInitialization: "ghlJOKvs0x",
      GetExcelData: "ihw6ZSTEM2",
      GetMessageSettings: "wn6aKVC5dp",
      SaveMessageSettings: "PEjTkQNUhU",
      GetMessageCredit: "ddYzgu8lSB",
      SaveMessageCredits: "cucHGCj3EU",
      GetMessageLogs: "zsAuv5BFYU",
      GetMessageCredits: "ytZD68raec",
      SavePrepaidDetail: "ua4vdbHG4d",
      GetPrepaidDetails: "b0unp6PLUq",
      GetPaymentFromWalletDetails: "KP6D950cjd",
      UpdateUpiByReceiptId: "P8vxxw9aM0",
      DeductFromPrepaid: "c95JUN8kCh",
      GetPaidByCompanyDetails: "mM7jPQ0a9m",
      GetPrepaidDeductPin: "oXHOUf1szk",
      SaveSeat: "nsTRMuh1uL",
      GetSeatTitles: "jB6CwVLPM4",
      ActiveInactiveStatus: "wv4bOkcsDo",
      UpdateSeatTitle: "optv4bnkW4",
      GetSeatsInitialization: "B72vXIuXIP",
      CreateSession: "RYzwC0Ha2V",
      ClearSession: "R37QsTteiA",
      GetActiveSessions: "qXiIKqEazd",
      GetSeatsBySessionId: "NpJyAzZdpg",
      GetSessionBySeat: "jvqBZuRaqf",
      ClearSeat: "HlNpykwKoS",
      AttachBill: "BUnDvqEhsq",
      GetBillsBySessionId: "zQAXFIUuBn",
      DetachBill: "ntBGPbWjCe",
      GetSessionsByBillingId: "sKXEnMiymZ",
      CreateQueue: "DmbTHugOon",
      GetQueues: "qggTSBGujg",
      ClearQueue: "xHJZGDuDUW",
      GetSessions: "xIJtfhJmyi",
      GetBillingStatusHistory: "pwnVrmWPhk",
      GetBillStatus: "vqlCzjjPfj",
      GetLiveTokens: "rAhvtehYXz",
      UpdateBillingStatusBulk: "FvxGPspYiI",
      PaidByCompany: "QnRrPbGeIw",
      GetReportData: "pgWYcZmCHW",
      GetReceiptOptionsForBusiness: "QnODPbGeIw",
      SaveReceiptOptions: "pgWYZcmCHW",
      GetReceiptOptionsHtml: "FvxGPPsYiI",
      SaveReceiptOptionsHtml: "vqlZcjjPfj",
      GetQrCodeImage: "BUnDqvEhsq",
      GetReceiptHtml: "zQAXIFUuBn",
      RemoveReceiptPrintCache: "DmbHTugOon",
      CreateBillingFromCartSession: "HlpNykwKoS",
      OnActionBillingDetail: "VPU1isA317",
      GetReceiptPrintLocal: "bJok4Qgc5T",
      GetReceiptPrintLocalByTemplateIds: "lIadQzzELk",
      SendNotificationForBilling: "iwh6ZSTEM2",
      GetCustomLabelPrintByBillingId: "HlNpkywKoS",
      SaveCustomLabelPrintByBillingId: "BUnvDqEhsq",
      DeleteBills: "B72vXIuXpi",
      UpdatePrice: "HhljvoMUGr",
      MarkProductStatus: "qeyTSBGujg",
      SavePaymentModeAmount: "ryhptNYpXr",
      GetPaymentModeAmount: "nwHt5kN2EY",
      GetLatestBillingId: "eIQnRrPbGw",
      GetReceiptHtmls: "MVsKM277Tc",
      SaveSavedCustomLabel: "OrsKM277Tc",
      GetSavedCustomLabels: "wesKM2rta1d",
      GetSavedCustomLabelDetails: "issKMWrst2c",
      ReformatInvoiceNumber: "Tes1isA317",
      GetTokenByBillingId: "kdst73nsfs",
      SaveImage: "s3VPU1iA17",
      SaveDiscountForBilledProduct: "LagajmdvmG",
      GetNewDummyBillingId: "vVHRs8sWfe",
      CreateNoConfigBilling: 'UQLp7O4jxc',
      GetNoConfigBillingSuggestion: 'N0D6sWfe',
      GetNoConfigBilling: 'q3E215kjkH',
      DeleteNoConfigBillingItem: 'ywHt5kN2EY',
      GetNoConfigBillings: 'VPU1is3b17',
      GetNoConfigBillingSettings: 'lqhWlUvnTj',
      SaveNoConfigBillingSettings: 'pabOsA2rM7',
      GetReceiptPrintCacheByTemplateIds: "bJkgQ4gc5T"
    }
  },
  configuration: {
    controller: "tsLQL9WWkOP7tMi/",
    methods: {
      SaveGeneralConfiguration: "bJokQ4gc5T",
      SaveField: "MJTPwb8QH5",
      SaveGlobalConfiguration: "lk4HwKSkaj",
      GetFields: "Lp7O4jUQxc",
      GetConfigurations: "n0Il2Gp0xi",
      GetGlobalConfigurations: "VPU1iAs317",
      ActiveInactiveStatus: "KsIoCcL2i0",
      GetConfiguration: "MVsKM2G8Tc",
      GetField: "lHqWlUvnTj",
      GetGlobalConfiguration: "ob9xkOFkOn",
      GetGlobalConfigurationByCode: "ppaOsA2rM7",
      GetConfigurationsToDisplay: "HhJlovMUGr",
      Backup: "QiGjIc1CzH",
      RunIndexes: "tNryhpYpXr",
      EnsureUniqueKeys: "ntBGPbWjCe",
      GetSummary: "Xc5Swaquya",
      GetGraph: "aYzVrN8tAr",
      GetExcelData: "elFSISSFH0",
      GenerateRent: "uSt2nartot",
      GetQrDetails: "QO7MaVRR8P",
      GetAllowedActionsSetup: "lIaQdzzELk",
      SaveAlowedActions: "PEsYkqsOZZ",
      GetPageActionsForUser: "Ht5knwN2EY",
      GetGuideTitlesToDisplay: "x8C94aQf7i",
      SaveGuide: "gajmLadvmG",
      GetGuide: "wL1r8ThePn",
      GetGuideContent: "tEC7wM20GN",
      UploadFile: "rpHY45TlEc",
      GetGalleries: "C5YHyzLMVI",
      SaveStartup: "x7qtZwQVg4",
      GetNextOrderStartUp: "HRsvV8sWfe",
      GetStartups: "w2oY0nZJ4q",
      GetStartUp: "ypcUtMnfS4",
      GetStartUpsToDisplay: "nd55e0v4Ah",
      IsUserHasAccess: "SYb1v69lFW",
      GetPageKeysRoleAccess: "aAfUvE0cfZ",
      GetAccessFile: "VO1AAuN2do",
      FixAccessRoleForPage: "YrCkVzsQ38",
      GetZippedGuides: "ukL8JxzZIt",
      DownloadGuidesManual: "r2VTlRwcSy",
      DownloadGuidesTitlesManual: "Qbo878SH8r",
      GetPaymentsGateway: "QH9ztgK4E7",
      SaveOnlyLanguagesConfig: "gmrC0USBEB",
      GetOnlyLanguagesConfig: "XdoWDpgRgX",
      SaveGetStartedMenus: "xa1FPq1Rd6",
      GetGetStartedMenus: "YX23eJZgpS",
      ApplyGetStartedSettings: "g7YHAnOqJd",
      GetTechnicalLogs: "jvqBZuRaqf",
      GetAdditionalServiceDetails: "HlNpykwKoS",
      ActivateAdditionalService: "BUnDvqEhsq",
      IsVersionMatched: "zQAXFIUuBn",
      GetCommunicationTemplateIds: "DmbTHugOon",
      SaveCommunicationTemplateIds: "sKXEnMiymZ",
      CopyAllGuideContentsToEnglish: "qggTSBGujg",
      EnsureDownTimeLog: "xHJZGDuDUW",
      GetConfigurationsToDisplayMulti: "HhJlovUMGr",
      GetReques: "QO7VaMRR8P",
      SaveDeviceInfoSetting: "s3VPU1iA17",
      GetDeviceInfoSetting: "LagajmdvmG",
      GetDeviceInfoSettings: "vVHRs8sWfe",
      AssignUserToDevice: 'UQLp7O4jxc',
      GetLocalNetworkSettings: "N0D6sWfe",
      GetLocalNetworkSetting: "q3E215kjkH",
      SaveLocalNetworkSetting: "ywHt5kN2EY",
      GetActiveLocalPrinterNamesMin: "VPU1is3b17",
      GetActiveLocalWeightMachineNamesByBusinessId: "lqhWlUvnTj"
    }
  },
  gallery: {
    controller: "spJRY9hiGGHtaEr/",
    methods: {
      GetGalleriesTech: "bJokQ4gc5T",
      GetGalleriesByType: "MJTPwb8QH5",
      SaveGallery: "lk4HwKSkaj",
      ActiveInactiveStatus: "Lp7O4jUQxc",
      RemoveGallery: "n0Il2Gp0xi",
      GetReceiptFiles: "VPU1iAs317",
      SaveGalleryTitle: "KsIoCcL2i0"
    }
  },
  country: {
    controller: "spJRY9hiBZHtaEr/",
    methods: {
      SaveCountry: "bJokQ4gc5T",
      GetCountryCodesToDisplay: "MJTPwb8QH5",
      GetContactCode: "lk4HwKSkaj",
      GetCountryCode: "Lp7O4jUQxc",
      GetCountries: "n0Il2Gp0xi",
      ActiveInactiveStatus: "VPU1iAs317",
      GetCountry: "KsIoCcL2i0",
      GetCountryPricing: "MVsKM2G8Tc",
      SaveCountryPricing: "lHqWlUvnTj",
      GetToolPricingInitialization: "ob9xkOFkOn",
      GetCountryByTimeZone: "ppaOsA2rM7"
    }
  },
  language: {
    controller: "nFaon8mKIe3ve0K/",
    methods: {
      GetLanguagesToDisplay: "bJokQ4gc5T",
      GetLanguages: "MJTPwb8QH5",
      GetLanguagesConfigSection: "lk4HwKSkaj",
      GetLanguageContentValue: "Lp7O4jUQxc",
      SaveLanguageContent: "n0Il2Gp0xi",
      GetLanguage: "VPU1iAs317",
      SaveLanguage: "KsIoCcL2i0",
      ActiveInactiveStatus: "MVsKM2G8Tc",
      SaveLanguageConfigValues: "lHqWlUvnTj",
      SaveLanguageConfigSection: "ob9xkOFkOn",
      GetLanguageConfigSection: "ppaOsA2rM7",
      GetLanguageContentToDisplayBySection: "HhJlovMUGr",
      GetLanguagesForContainer: "QiGjIc1CzH",
      GetLanguageContainerSimple: "tNryhpYpXr",
      SaveLanguageContainerSimple: "Xc5Swaquya",
      GetMemberApplicationLanguageIdByMemberId: "aYzVrN8tAr",
      GetWords: "elFSISSFH0",
      GetLanguageContainer: "uSt2nartot",
      GetTranslatedTextByLanguages: "QO7MaVRR8P",
      RefreshSearchValue: "lIaQdzzELk",
      UpdateAutoTranslationBulk: "PEsYkqsOZZ",
      GetLanguageHistories: "Ht5knwN2EY",
      GetLanguagesConfigSectionByKey: "x8C94aQf7i",
      RefreshSearchValueBulk: "gajmLadvmG",
      DeleteLanguage: "wL1r8ThePn",
      CorrectInvalidProductNameTranslation: "tEC7wM20GN",
    }
  },
  location: {
    controller: "NsWsofN3jkDY5KC/",
    methods: {
      GetChildLocations: "bJokQ4gc5T",
      GetLocations: "MJTPwb8QH5",
      ActiveInactiveStatus: "lk4HwKSkaj",
      GetLocation: "Lp7O4jUQxc",
      SaveLocation: "n0Il2Gp0xi",
      GetGlobalLocations: "VPU1iAs317",
      GetLocationFile: "KsIoCcL2i0",
      GetLocationsWithRoots: "MVsKM2G8Tc"
    }
  },
  menu: {
    controller: "Rpo5zYWKsdqJXCn/",
    methods: {
      SaveMenu: "bJokQ4gc5T",
      GetMenus: "MJTPwb8QH5",
      GetMenu: "lk4HwKSkaj",
      ActiveInactiveStatus: "Lp7O4jUQxc",
      GetNextOrder: "n0Il2Gp0xi",
      GetHeader: "VPU1iAs317",
      GetPublicMenus: "KsIoCcL2i0",
      GetNotifications: "MVsKM2G8Tc",
      MarkAsRead: "lHqWlUvnTj",
      GetMenusUsedByPageKeys: "ob9xkOFkOn",
      SaveCustomizeMenu: "ppaOsA2rM7",
      GetActivePageKeys: "HhJlovMUGr",
      GetShortenUrl: "QiGjIc1CzH"
    }
  },
  product: {
    controller: "igBuwRr3KFR5APR/",
    methods: {
      SaveProduct: "bJokQ4gc5T",
      GetProductInitialization: "MJTPwb8QH5",
      GetProducts: "lk4HwKSkaj",
      GetProduct: "Lp7O4jUQxc",
      GetSearchedProduct: "n0Il2Gp0xi",
      GetAllProductsToDisplay: "VPU1iAs317",
      AddStock: "KsIoCcL2i0",
      GetPrice: "MVsKM2G8Tc",
      SaveSerialNumber: "lHqWlUvnTj",
      GetSerialNumbersInitialization: "ob9xkOFkOn",
      GetSerialNumber: "ppaOsA2rM7",
      GetSerialNumbers: "HhJlovMUGr",
      GetAvailableSerialNumbers: "QiGjIc1CzH",
      DownloadProducts: "tNryhpYpXr",
      GetProductLogs: "Xc5Swaquya",
      GetProductLogDetailsInitialization: "aYzVrN8tAr",
      GetProductLogDetails: "elFSISSFH0",
      GetPricingManagment: "uSt2nartot",
      ActiveInactiveStatus: "QO7MaVRR8P",
      GetUsageLimits: "lIaQdzzELk",
      GetUsageLimitConfigs: "PEsYkqsOZZ",
      GenerateSerialNumbers: "x8C94aQf7i",
      IsValidSerialNumber: "gajmLadvmG",
      GetItemsToDisplay: "ppasOA2rM7",
      SaveCartSession: "lk4wHKSkaj",
      GetCartSession: "MVsMK2G8Tc",
      GetStockReport: "HhJlvoMUGr",
      GetBatchTitleWithInventory: "MVsk3m2G8Tc",
      SavePrice: "QRRT7MaVRR8P",
      DeletePrice: "XcSSDwaquya",
      SaveCustomField: "ppas2AsrM7",
      GetCustomFields: "ob9xFokkOn",
      SaveChildMeasurementForProduct: "wL1r8ThePn",
      GetChildMeasurementForProduct: "tEC7wM20GN",
      GetChildMeasurementsForProduct: "rpHY45TlEc",
      GetProductIdOfBarCode: "C5YHyzLMVI",
      UpdateBaseAmount: "x7qtZwQVg4",
      SaveProductRawInventoryConfig: "HRsvV8sWfe",
      GetProductRawInventoryConfigs: "w2oY0nZJ4q",
      GetMonthlyStockReport: "ypcUtMnfS4",
      GetStockCount: "nd55e0v4Ah"
    }
  },
  profile: {
    controller: "uGq0ftlhxBLQ2r7/",
    methods: {
      SaveMember: "bJokQ4gc5T",
      VerifyOtp: "MJTPwb8QH5",
      SavePwd: "lk4HwKSkaj",
      GetLoggedMember: "Lp7O4jUQxc",
      SendOtp: "n0Il2Gp0xi",
      SaveRelationShip: "VPU1iAs317",
      EditRelationShip: "KsIoCcL2i0",
      GetRelationshipInitialization: "MVsKM2G8Tc",
      GetRelationships: "lHqWlUvnTj",
      ActiveInactiveStatus: "ob9xkOFkOn",
      SaveCredits: "ppaOsA2rM7",
      GetUserInitialization: "HhJlovMUGr",
      GetMembers: "QiGjIc1CzH",
      GetPaymentInitialization: "tNryhpYpXr",
      GetMyPayments: "Xc5Swaquya",
      SaveLastUsedSettings: "aYzVrN8tAr",
      GetLastUsedSettings: "elFSISSFH0",
      SavePayment: "uSt2nartot",
      SaveServiceProvider: "QO7MaVRR8P",
      GetDelivererInitialization: "lIaQdzzELk",
      GetDeliverer: "xzkLgFs5hi",
      GetEmptyDeliverer: "PEsYkqsOZZ",
      GetMyDeliverer: "Ht5knwN2EY",
      ToggleDeliver: "x8C94aQf7i",
      GetDeliverers: "gajmLadvmG",
      GetPinnedDeliverers: "wL1r8ThePn",
      SavePinnedDeliverers: "tEC7wM20GN",
      GetInvoice: "rpHY45TlEc",
      GetUserInfo: "C5YHyzLMVI",
      EditSystemInfo: "x7qtZwQVg4",
      SaveSystemInfo: "HRsvV8sWfe",
      EditAdditionalDetails: "w2oY0nZJ4q",
      SaveAdditionalDetails: "ypcUtMnfS4",
      OnAction: "nd55e0v4Ah",
      SaveUserAccess: "SYb1v69lFW",
      GetAccessInitialization: "aAfUvE0cfZ",
      GetUserAccess: "VO1AAuN2do",
      GetBrnDetails: "YrCkVzsQ38",
      GetBrnDetailsByUser: "ukL8JxzZIt",
      GetDeliveryAddresses: "r2VTlRwcSy",
      SaveDeliveryAddess: "Qbo878SH8r",
      GetDeliveryAddress: "QH9ztgK4E7",
      AddWhiteList: "gmrC0USBEB",
      GetWhiteLists: "0BYJA9OVf1",
      UpdateStatus: "XdoWDpgRgX",
      GetWhitelist: "xa1FPq1Rd6",
      GetMember: "YX23eJZgpS",
      GetBrnDetailsByQr: "g7YHAnOqJd",
      IsAllowedForItem: "3PnJeFC5hJ",
      GetCreditlogs: "PsWjtHibU4",
      GetLessAlert: "idFmoIR9j0",
      NewComplaint: "HrOJpzOYRy",
      NewComplaintDetail: "kbRaoBoz6N",
      GetComplaintsInitialization: "QToECG0Eal",
      GetComplaints: "LLyEi7WsYw",
      GetComplaintDetails: "ghlJOKvs0x",
      GetComplaintStatus: "ihw6ZSTEM2",
      UpdateComplaintStatus: "wn6aKVC5dp",
      GetWorkingAsDetail: "PEjTkQNUhU",
      GetAssociatedAccounts: "ddYzgu8lSB",
      BlockUnblockAccounts: "cucHGCj3EU",
      GetPendingPayment: "zsAuv5BFYU",
      GetReference: "ytZD68raec",
      GetMemberName: "ua4vdbHG4d",
      GetUpi: "b0unp6PLUq",
      ResetCurrentToken: "KP6D950cjd",
      GetRentReceiptLogs: "P8vxxw9aM0",
      SendMessageToPhone: "c95JUN8kCh",
      GetDefautContactNumbersToSend: "mM7jPQ0a9m",
      UpdateDeliveryAddress: "oXHOUf1szk",
    }
  },
  request: {
    controller: "Kqzl4oaMGsHnDno/",
    methods: {
      CreateRequest: "bJokQ4gc5T",
      CreateTestData: "MJTPwb8QH5",
      GetRequestInitialization: "lk4HwKSkaj",
      GetRequests: "Lp7O4jUQxc",
      CheckContentLength: "n0Il2Gp0xi",
      RetryJob: "VPU1iAs317",
      DownloadExcelTemplate: "KsIoCcL2i0",
      GetBulkLogDetailsInitialization: "MVsKM2G8Tc",
      GetBulkLogDetails: "lHqWlUvnTj"
    }
  },
  seller: {
    controller: "rfMLneTfDVqiERI/",
    methods: {
      GetSellerInitialization: "bJokQ4gc5T",
      SaveBusiness: "MJTPwb8QH5",
      GetBusinesses: "lk4HwKSkaj",
      GetBusiness: "Lp7O4jUQxc",
      GetSearchInitialization: "n0Il2Gp0xi",
      GetSearchResults: "VPU1iAs317",
      GetSearchResultsLanguage: "KsIoCcL2i0",
      GetBusinessInitialization: "MVsKM2G8Tc",
      GetBusinessesAdmin: "lHqWlUvnTj",
      GetAppointments: "ob9xkOFkOn",
      ActionOnAppointment: "ppaOsA2rM7",
      AddProductCategory: "HhJlovMUGr",
      UpdateProductCategory: "QiGjIc1CzH",
      GetProductCategories: "tNryhpYpXr",
      GetProductCategory: "Xc5Swaquya",
      DeleteProductCategory: "aYzVrN8tAr",
      ActiveInactiveStatus: "elFSISSFH0",
      GetBusinessName: "uSt2nartot",
      SavePaymentDetail: "QO7MaVRR8P",
      GetPaymentDetails: "lIaQdzzELk",
      SaveWorkingHoursRange: "PEsYkqsOZZ",
      GetWorkingRange: "Ht5knwN2EY",
      GetBusinesesBySearchKey: "x8C94aQf7i",
      GetBusinessRelationShipRolesForUser: "gajmLadvmG",
      IsBusinessOptionEnabled: "PEsYkqDwZZ",
      GetBusinessEnabledOptions: "QO7aMVRR8P",
      SaveBillingAdjustmentFormula: "PEsKyqsOZZ",
      GetBillingAdjustmentFormulas: "uSt2anrtot",
      RefreshBusinesses: "Lp7O4jyrxc",
      SavePrintIconDimensions: "YX23eJZgpS",
      GetExpectedBusinessTypes: "g7YHAnOqJd",
      GetBusinessTaxCategories: "3PnJeFC5hJ",
      SaveBusinessTaxCategory: "PsWjtHibU4",
      GetBusinessTaxesFull: "idFmoIR9j0",
      GetBusinessesByContactNumber: "HrOJpzOYRy",
      ResetCurrentAcceptanceNumber: "kbRaoBoz6N",
      GenerateOtpForBusinessIdentificationCode: "QToECG0Eal",
      GetBusinessByBusinessIdentificationCode: "LLyEi7WsYw",
      CloneBusiness: "ghlJOKvs0x",
    }
  },
  payment: {
    controller: "jC6F3QLdaCxz5XF/",
    methods: {
      GetOrderId: "bJokQ4gc5T",
      GetPaymentGatewayOrderStatus: "MJTPwb8QH5",
      UpdatePaymentGatewayResponse: "lk4HwKSkaj",
      SavePaymentGatewayCustomer: "Lp7O4jUQxc",
      GetPaymentGatewayCustomer: "n0Il2Gp0xi",
      GetPaymentQrType: 'KsIoCcL2i0',
      SavePaymentQrType: 'MVsKM2G8Tc',
      SavePaymentGatewayCustomerFundAccountExternal: 'lHqWlUvnTj'
    }
  },
  supplier: {
    controller: "zdsdQLdaCxz5qts/",
    methods: {
      GetSupplierInitialization: "bJokQ4gc5T",
      GetSupplier: "MJTPwb8QH5",
      SaveSupplier: "lk4HwKSkaj",
      GetSuppliers: "Lp7O4jUQxc",
      ActiveInactiveStatus: "n0Il2Gp0xi",
      GetSearchedSuppliers: "VPU1iAs317"
    }
  },
  purchaseEntry: {
    controller: "rfMLneTfRIqiEDV/",
    methods: {
      GetPurchaseEntryInitialization: "bJokQ4gc5T",
      GetPurchaseEntry: "MJTPwb8QH5",
      SavePurchaseEntry: "lk4HwKSkaj",
      GetPurchaseEntries: "Lp7O4jUQxc",
      ActiveInactiveStatus: "n0Il2Gp0xi",
      GetNextPurchaseEntryReference: "VPU1iAs317",
      GetPurchaseEntryDetailsInitialization: "KsIoCcL2i0",
      GetPurchaseEntryDetails: "MVsKM2G8Tc",
      GetSearchedProducts: "lHqWlUvnTj",
      SavePurchaseEntryDetail: "ob9xkOFkOn",
      UpdatePurchaseEntryDetail: "ppaOsA2rM7",
      GetPurchaseEntryHistories: "HhJlovMUGr"
    }
  },
  lookup: {
    controller: "Kqzl4oaGMsHnDnDo/",
    methods: {
      SaveLookup: "bJokQ4gc5T",
      GetLookup: "MJTPwb8QH5",
      GetLookups: "lk4HwKSkaj",
      ActiveInactiveStatus: "Lp7O4jUQxc",
      DeleteLookups: "n0Il2Gp0xi",
      DeleteLookup: "VPU1iAs317"
    }
  },
  printer: {
    controller: "bJokQ4gc5TqsGN1w/",
    methods: {
      GetPrinterNames: "bJokQ4gc5T",
      SavePrinterNames: "MJTPwb8QH5",
      GetPrinterTemplates: "lk4HwKSkaj",
      SavePrinterTemplate: "Lp7O4jUQxc",
      GetPrinterTemplateMaps: "n0Il2Gp0xi",
      SavePrinterTemplateMap: "VPU1iAs317",
      GetPrinterDeviceMaps: "KsIoCcL2i0",
      SavePrinterDeviceMap: "MVsKM2G8Tc",
      IsPrinterNameAvailable: "lHqWlUvnTj",
      IsPrinterTemplateAvailable: "ob9xkOFkOn",
      IsPrinterTemplateMapAvailable: "ppaOsA2rM7",
      IsPrinterDeviceMapAvailable: "HhJlovMUGr",
      IsPrinterTabAvailable: "QiGjIc1CzH",
      IsPrinterDeviceAvailable: "tNryhpYpXr",
      GetPrinterDevices: "Xc5Swaquya",
      SavePrinterDevice: "aYzVrN8tAr",
      GetPrinterTemplate: "elFSISSFH0",
      GetPrinterTemplateMap: "uSt2nartot",
      GetPrinterDeviceMap: "QO7MaVRR8P",
      GetPrinterDevice: "lIaQdzzELk",
      ActiveInactiveStatus: "xzkLgFs5hi",
      SavePrinterSetup: "QToECG0Eal",
      GetPrinterSetupByBusinessId: "LLyEi7WsYw",
      GetPrinterSetupsByDeviceId: "ghlJOKvs0x",
      GetPrinterSetupByBusinessIds: "ihw6ZSTEM2",
      GetCustomLabelPrints: "wn6aKVC5dp",
      SaveCustomLabelPrint: "PEjTkQNUhU",
      GetCustomLabelPrintById: "ddYzgu8lSB",
      GetCustomLabelPrintsMin: "Xcs6waquya",
      SaveFontSetting: "ua4dvbHG4d",
      GetPrintReceiptIconsByBusinessId: "Lp746jUQxc",
      GetPrintFontSettingByBusinessId: "b0un7pPLUq",
      GetCustomLabelPrintsMinInitialization: "HhovovMUGr"
    }
  },
  planPurchase: {
    controller: "zdsddLQaCxz5qts/",
    methods: {
      GetNewPlanPurchaseInvoice: "bJokQ4gc5T",
      SetInvoiceStatus: "MJTPwb8QH5",
      SavePlanPurchaseInvoiceDetail: "lk4HwKSkaj",
      GetPlanPurchaseInvoiceInitialization: "Lp7O4jUQxc",
      GetPlanPurchaseInvoices: "n0Il2Gp0xi",
      GetPlanPurchaseInvoiceDetail: "VPU1iAs317",
      GetPlanPurchaseInvoiceDetailInitialization: "KsIoCcL2i0",
      DeletePlanPurchaseInvoiceDetail: "MVsKM2G8Tc",
      BuyPlanPurchaseInvoice: "lHqWlUvnTj",
      GetInvoice: "ob9xkOFkOn",
      GetInvoices: "ppaOsA2rM7",
      GetExcelData: "HhJlovMUGr",
      UploadInvoiceToDrive: "QiGjIc1CzH",
      RemoveToGst: 'tNryhpYpXr',
      RefreshToGst: "Xc5Swaquya",
      GetB2bLicenseSummary: "aYzVrN8tAr",
      GetUtilizedLincenseDetails: "elFSISSFH0",
      GetPlanSubscriptions: "uSt2nartot",
    }
  },
  batchEntry: {
    controller: "rfMLneFtRIqiEDV/",
    methods: {
      GetBatchEntryInitialization: "bJokQ4gc5T",
      GetBatchEntry: "MJTPwb8QH5",
      SaveBatchEntry: "lk4HwKSkaj",
      GetBatchEntries: "Lp7O4jUQxc",
      ActiveInactiveStatus: "n0Il2Gp0xi",
      GetBatchEntryDetailsInitialization: "KsIoCcL2i0",
      GetBatchEntryDetails: "MVsKM2G8Tc",
      GetSearchedProducts: "lHqWlUvnTj",
      SaveBatchEntryDetail: "ob9xkOFkOn",
      UpdateBatchEntryDetail: "ppaOsA2rM7"
    }
  },
  qrPayment: {
    controller: "rmmFLneFtRIqiEDV/",
    methods: {
      GetQrPaymentLogs: "KsIoCcL2i0",
      GetQrPaymentTitles: "MVsKM2G8Tc",
      GenerateQrCode: "VPU1iAs317",
      SaveQrPaymentConfig: "bJokQ4gc5T",
      GetQrPaymentConfigs: "MJTPwb8QH5",
      GetQrPaymentConfig: "lk4HwKSkaj",
      ActiveInactiveStatus: "Lp7O4jUQxc",
      GetConfiguredPaymentGateways: "n0Il2Gp0xi",
      UpdateBusinessPrimaryPaymentGateway: "lHqWlUvnTj",
      GetQrPaymentLogStatusById: "ob9xkOFkOn"
    }
  },
  qrlabel: {
    controller: "HtspJRY9hiGGaEr/",
    methods: {
      SaveQrLabelTemplate: "bJokQ4gc5T",
      GetQrLabelTemplate: "MVsKM2G8Tc",
      GetQrLabelTemplates: "VPU1iAs317",
      DeletQrLabelTemplate: "KsIoCcL2i0",
      GetFontOptions: "MJTPwb8QH5",
      SaveQrLabelVariable: "lk4HwKSkaj",
      GetQrLabelVariable: "Lp7O4jUQxc",
      GetQrLabelVariables: "n0Il2Gp0xi",
      ActiveInactiveStatus: "lHqWlUvnTj",
      GetLabelHtml: "ob9xkOFkOn",
      GetQrLabelPrintLastSetting: 'ppaOsA2rM7',
      GetQrLabelTemplatesToDisplay: 'HhJlovMUGr',
      GetUploadedQrValues: 'QiGjIc1CzH'
    }
  },
  report: {
    controller: "kusdQLdaCxz5qts/",
    methods: {
      SetSaleSettlement: "bJokQ4gc5T",
      GetSaleSettlements: "MVsKM2G8Tc"
    }
  },
  authConfig: {
    controller: "kusdQkuaCxz5qts/",
    methods: {
      SaveAuthConfig: "bJokQ4gc5T",
      GetAuthConfig: "MVsKM2G8Tc"
    }
  },
  b2b: {
    controller: "disdQkuaCxz5qts/",
    methods: {
      SaveB2bAccount: "bJokQ4gc5T",
      SaveB2bOwner: "MVsKM2G8Tc",
      GetB2bAccounts: "VPU1iAs317",
      GetB2bAccount: "KsIoCcL2i0",
      GetB2bOwners: "MJTPwb8QH5",
    }
  },
  tasks: {
    controller: "dQkuaoebCxz5qts/",
    methods: {
      CreateTaskRequest: "bJokQ4gc5T",
      GetTaskOwners: "MVsKM2G8Tc",
      GetTaskRequestsInitialization: "VPU1iAs317",
      GetTaskRequests: "KsIoCcL2i0",
      GetTaskRequest: "MJTPwb8QH5",
      UpdateTaskStatus: "lk4HwKSkaj",
      UpdateTaskRequest: "Lp7O4jUQxc",
      SendTaskRequestAlerts: "n0Il2Gp0xi",
    }
  },
  auditing: {
    controller: "TtspJRY9hiGGaEr/",
    methods: {
      GetExpensesInitialization: "bJokQ4gc5T"
    }
  },
};